import React, { useState } from 'react'
import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box } from '@mui/system'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { detailColumnsStyles, jsPdfHeaderFooter, pdfHeaderColumn, DetailsDrawCell, excelHeader, PDFHeaderDetailedColumns, detailColumnsStylesTwo, DetailsDrawCellTwo, excelHeaderTwo } from './constants'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { useSelector } from 'react-redux'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'

const FranchiseOutstandingReportDetailedTable = (props) => {
const { headerData, tablesData, sourceBranch } = props
const theme = useTheme()
const { tableHeaderColor } = theme
const { loginData } = useSelector((state) => state?.common)

const [searchResult, setSearchResult] = useState(true)
const [largePDF, setLargePDF] = useState(false)
const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })

const formatGroupedTableData = (tablesData) => {
  if (!Array.isArray(tablesData) || tablesData.length === 0) return [];

  const grouped = {};

  // Group by Source + Destination combo
  for (const item of tablesData) {
    const srcKey = `${item.BookingCityName || ''}__${item.BranchName || ''}`;
    const destKey = `${item.DestinationCityName || ''}__${item.DestinationBranchName || ''}`;
    const groupKey = `${srcKey}::${destKey}`;

    if (!grouped[groupKey]) grouped[groupKey] = [];
    grouped[groupKey].push(item);
  }

  const result = [];
  let serialNo = 1;
  let grandTotalItems = 0;
  let grandTotalAmount = 0;

  for (const groupKey in grouped) {
    const [src, dest] = groupKey.split('::');
    const [srcCity, srcBranch] = src.split('__');
    const [destCity, destBranch] = dest.split('__');

    result.push({
      isSubHeading: true,
      SN: `Source City : ${srcCity}`,
      SenNameMob: `Destination City : ${destCity}`
    });

    let groupItemsTotal = 0;
    let groupAmountTotal = 0;

    for (const item of grouped[groupKey]) {
      const row = {
        isDataRow: true,
        SN: serialNo++,
        LRManLRno: item.LRNO || '',
        BKGDateTime: item.BookingDate || '',
        SrcCityBranch: `${item.BookingCityName || ''}\n${item.BranchName || ''}`,
        DestCityBranch: `${item.DestinationCityName || ''}\n${item.DestinationBranchName || ''}`,
        SenNameMob: `${item.SenderName || ''}\n${item.SenderMobileNo || ''}`,
        RecNameMob: `${item.RecName || ''}\n${item.RecMobileNo || ''}`,
        PaymentType: item.PaymentType || '',
        Status: item.LRStatus || '',
        Items: item.Items || 0,
        NetAmount: item.GrossAmount || 0
      };

      groupItemsTotal += row.Items;
      groupAmountTotal += row.NetAmount;
      result.push(row);
    }

    // Add group total
    result.push({
      isTotal: true,
      SN: 'Total',
      Items: groupItemsTotal,
      NetAmount: groupAmountTotal
    });

    grandTotalItems += groupItemsTotal;
    grandTotalAmount += groupAmountTotal;
  }

  // Add grand total at end
  result.push({
    isGrandTotal: true,
    SN: 'Grand Total',
    Items: grandTotalItems,
    NetAmount: grandTotalAmount
  });

  return result;
}
const filteredData = formatGroupedTableData(tablesData);

  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')

  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = pdfHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = PDFHeaderDetailedColumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Franchise Outstanding Reports.pdf`,
      subject: 'Franchise Outstanding Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [headerData],
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        4: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        5: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        6: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        7: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
      },
    })

    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'top',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: filteredData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      theme: 'grid',
      columnStyles: detailColumnsStylesTwo,
      didParseCell: (data) => {
        DetailsDrawCellTwo(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System |  Franchise Outstanding Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Franchise Outstanding Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Franchise Outstanding Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('gbDetailsOutput').data = pdfUrl
        // document.getElementById('gbDetailsOutput').data = doc.output('datauristring', ' Franchise Outstanding Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
const InsideRowContent = ({ item, index, fs = '12px' }) => {
  return (
    <TableRow className="receivedTr" key={index}>
      {item?.isSubHeading ? (
        <>
        <TableCell
          className="userwiseTD"
          colSpan={5}
          style={{ padding: '8px 9px', textAlign: 'left', verticalAlign: 'top', backgroundColor: tableHeaderColor?.isSubHeadingColor }}
        >
          {item.SN}
        </TableCell>
        <TableCell
          className="userwiseTD"
          colSpan={6}
          style={{ padding: '8px 9px', textAlign: 'right', verticalAlign: 'top', backgroundColor: tableHeaderColor?.isSubHeadingColor }}
        >
          {item.SenNameMob}
        </TableCell>
        </>
      ) : item?.isGrandTotal ? (
        <>
          <TableCell className="userWiseReportSubTotal" colSpan={9} style={cellStyle(fs, tableHeaderColor?.isTotalColor, 'right')}>
            {item.SN}
          </TableCell>
          <TableCell className="userWiseReportSubTotal" colSpan={1} style={cellStyle(fs, tableHeaderColor?.isTotalColor, 'right')}>
            {item.Items}
          </TableCell>
          <TableCell className="userWiseReportSubTotal" colSpan={1} style={cellStyle(fs, tableHeaderColor?.isTotalColor, 'right')}>
            <span style={{ color: '#0086FF' }}>{item.NetAmount}</span>
          </TableCell>
        </>
      ) : item?.isTotal ? (
        <>
          <TableCell className="userWiseReportSubTotal" colSpan={9} style={cellStyle(fs, tableHeaderColor?.isTotalColor, 'right')}>
            {item.SN}
          </TableCell>
          <TableCell className="userWiseReportSubTotal" colSpan={1} style={cellStyle(fs, tableHeaderColor?.isTotalColor, 'right')}>
            {item.Items}
          </TableCell>
          <TableCell className="userWiseReportSubTotal" colSpan={1} style={cellStyle(fs, tableHeaderColor?.isTotalColor, 'right')}>
            <span style={{ color: '#0086FF' }}>{item.NetAmount}</span>
          </TableCell>
        </>
      ) : (
        <>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.SN}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.LRManLRno}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.BKGDateTime}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.SrcCityBranch}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.DestCityBranch}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.SenNameMob}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.RecNameMob}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.PaymentType}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'left')}>{item.Status}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'right')}>{item.Items}</TableCell>
          <TableCell className="userwiseTD" colSpan={1} style={tdStyle(fs, 'right')}>
            <span style={{ color: '#0086FF' }}>{item.NetAmount}</span>
          </TableCell>
        </>
      )}
    </TableRow>
  )
}

const tdStyle = (fs, align) => ({
  padding: '8px 9px',
  textAlign: align,
  verticalAlign: 'top',
  fontSize: fs,
})

const cellStyle = (fs, bgColor, align) => ({
  padding: '8px 9px',
  textAlign: align,
  backgroundColor: bgColor,
  height: '36px',
  fontSize: fs,
})

  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Item className="userReport-heading">Report For: Franchise Outstanding Report</Item>
          <Item className="userReport-buttons">
            {searchResult ? (
              <>
                <Box onKeyDown={(e) => navigation3(e, 'ExportToPdf', id.reportmainButton, () => {})}>
                  <ReactHtmlTableToExcel
                    id="ExportToExl"
                    className="userWisereporttemExcelBtn"
                    table="table-gbDetailsTableReport-xls"
                    filename={`Franchise Outstanding Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    id="ExportToPdf"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'PrintBtn', 'ExportToExl', () => {
                        setSearchResult(false)
                        printClick(true)
                      })
                    }
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    id="PrintBtn"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      printClick(false)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, 'ExportToPdf', () => {
                        setSearchResult(true)
                        printClick(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    id="backBtn"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, id.reportmainButton, () => {
                        setSearchResult(true)
                        setLargePDF(false)
                        focusElemnt(id.reportmainButton)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {searchResult ? (
        <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
          <TableContainer
            className="lr-popup-table lrModel "
            component={Paper}
            style={{ borderRadius: '6px', border: '1px solid #aeaeae' }}
          >
            <>
              <Table size="small" aria-label="a dense table">
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                  <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                    {PDFHeaderDetailedColumns?.map((item, i) => (
                      <TableCell
                        className="userWiseReportHeading"
                        key={i}
                        style={{
                          textAlign: item.align,
                          verticalAlign: 'top',
                          color: tableHeaderColor.textColor,
                          backgroundColor: tableHeaderColor.isHeadingColor,
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {item?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {filteredData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : filteredData.length > 0 ? (
                  <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                    {filteredData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} fs={'12px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              {/* -----for Excel---- */}
              <Table size="small" aria-label="a dense table" id="table-gbDetailsTableReport-xls" style={{ display: 'none' }}>
                <TableHead style={{ position: `sticky`, top: `0`, background: `white`, borderRadius: '10px 10px 10px 10px' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For: Franchise Outstanding Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '600', textAlign: 'left' }} colSpan={6}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderTwo?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444444', fontSize: '12px', fontWeight: '600', textAlign: 'left' }}
                        colSpan={item.colSpan}
                        key={i}
                      >
                        {item.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {moment(headerData.fromDate).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {moment(headerData.toDate).format('DD/MM/YYYY')}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.sourceCity}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                      {headerData?.sourceBranch}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.destinationCity}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                      {headerData?.destinationBranch}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={1}>
                      {headerData?.paymentType}
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '12px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                      {headerData?.reportView}
                    </TableCell>
                  </TableRow>
                  <TableRow className="sammary-heading" style={{ borderRadius: '10px 10px 10px 10px' }}>
                    {PDFHeaderDetailedColumns?.map((item, i) => (
                      <TableCell
                        className="userWiseReportHeading"
                        key={i}
                        style={{
                          textAlign: item.align,
                          verticalAlign: 'top',
                          color: tableHeaderColor.textColor,
                          backgroundColor: tableHeaderColor.isHeadingColor,
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {item?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {filteredData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : filteredData.length > 0 ? (
                  <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                    {filteredData?.map((item, index) => (
                      <InsideRowContent item={item} index={index} key={index} fs={'14px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </>
          </TableContainer>
        </Stack>
      ) : (
        <>
          <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
            {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
            {load ? (
              <object
                id="gbDetailsOutput"
                type="application/pdf"
                width={'100%'}
                height="440"
                title="MTLPL -Cargo System -Franchise Outstanding Report"
                aria-label="MTLPL -Cargo System -Franchise Outstanding Report"
              ></object>
            ) : (
              ''
            )}
          </Box>
        </>
      )}
    </>
  )
}

export default FranchiseOutstandingReportDetailedTable
